import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Spinner, InputGroup, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import RenderizarProduto from '../Utils/RenderizarProduto';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useProvider, Toast } from '../../context/MenuProvider';


const Home = ( ) => {
  const [formType, setFormType] = useState('empresas'); 
  const [empresa, setEmpresa] = useState(null); 
  

  return (
    <>
      <Form.Group controlId="formSelectStockFilter" className="mb-2">
        <InputGroup>
          <span className="input-group-text">Tipo</span>
          <Form.Control 
            as="select" 
            value={formType} 
            onChange={(e) => setFormType(e.target.value)}
          >
            <option value="empresas">Empresas</option>
            <option value="todos-produtos">Todos Produtos</option>
            <option value="produtos" disabled={!empresa}>Produtos de {empresa ? empresa.nome_da_loja : "Empresa selecionada"}</option>
          </Form.Control>
        </InputGroup>
      </Form.Group>

      {formType === "empresas" && (
        <Empresas 
          setEmpresa={setEmpresa} 
          setFormType={setFormType} 
        />
      )}

      {formType === "todos-produtos" && (
        <Produtos 
          setFormType={setFormType} 
        />
      )}

      {formType === "produtos" && empresa && (
        <Produtos 
          empresa={empresa} 
          setFormType={setFormType} 
        />
      )}
    </>
  );
};

const Empresas = ({setEmpresa, setFormType}) => {
    const {
      crud
    } = useProvider();
    const { get, loading } = crud || {};
    const [catalogos, setEmpresas] = useState([]);
    const [query, setQuery] = useState('');
    const [nextUrl, setNextUrl] = useState(null);
    
    useEffect(() => {
      buscarEmpresas(true); // Sempre faz uma nova busca
    }, [query]);
    
    
    const buscarEmpresas = async (novaBusca = false) => {
        let url = `/gvendas/empresas/?empresa_produtos__is_compartilhar=true`;
        if (query) url += `&search=${query}`;
        
        if (novaBusca) {
            setEmpresas([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        try{
          const response = await get(url, 'pagina', false);
          if (response && response.length){
            const novosItens = response[0].results;
            setEmpresas((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
            setNextUrl(response[0].next);
          }
          
        }catch(err){
          // Toast.fire({
          //   icon: "error",
          //   title: "Falha ao buscar pagamentos"
          // });
        }finally{
          
        }
    };
    
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarEmpresas();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading]);
    
    return (
        <>
            <div className="">
                <Form>
                    <Form.Group controlId="formBasicSearch">
                      <div className="input-group">
                        <Form.Control 
                            type="text" 
                            placeholder="Pesquisar pelo nome" 
                            value={query} 
                            onChange={(e) => setQuery(e.target.value)} 
                        />
                        <Button variant="secondary" onClick={() => buscarEmpresas(true)}>
                            <i className="bi bi-search"></i>
                        </Button>
                      </div>
                    </Form.Group>
                </Form>
                
                <Card className="p-2 mt-3">
                  Lista de catálogos individuais disponíveis para clonar para seu estoque. Fique a vontade para adicionar um produto selecionado ou o catálogo completo.
                </Card>

                <div className="list-group mt-3">
                    {catalogos?.length > 0 ? (
                      catalogos.map((x) => (
                        <RenderizarProduto
                          key={x.id}
                          onClick={()=>{setEmpresa(x);setFormType('produtos')}}
                          src={x.logomarca}
                          text1={x.telefone_whatsapp}
                          titulo={x.nome_da_loja}
                        />
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhuma empresa encontrada.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarEmpresas(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};

const Produtos = ({empresa, setFormType}) => {
    const {
      crud,
      navigateTo,
    } = useProvider();
    const [avancada, setAvancada] = useState(false); 
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [produtos, setProdutos] = useState([]); // Produtos carregados
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página
    
    const { get, post, loading } = crud || {};  // Obtendo os métodos do hook useCrud
    

    // Função para buscar produtos na API
    const buscarProdutos = async (novaBusca = false) => {
        let url = `/gvendas/produtos/?ordering=nome_do_produto&filtros=nome_do_produto,foto_do_produto,preco_unitario,id,nome_da_loja`;

        if (query) url += `&search=${query}`;
        if (empresa) url += `&empresa=${empresa?.id}`;
        if (!empresa) url += `&expand=empresa`;

        if (novaBusca) {
            setProdutos([]); // Limpa os produtos anteriores
            setNextUrl(null); // Reseta o nextUrl
        } else if (nextUrl) {
            url = nextUrl; // Se não for nova busca, utiliza o nextUrl
        } else {
          url = null;
        }

        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url, 'pagina', false);
          if (response && response.length){
            const novosProdutos = response[0].results; // Corrigir para acessar o resultado correto
            setProdutos((produtosAnteriores) => novaBusca ? novosProdutos : [...produtosAnteriores, ...novosProdutos]);
            setNextUrl(response[0].next);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar produtos"
          // });
        }finally{
          
        }
    };

    // Carrega os produtos ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      buscarProdutos(true); // Sempre faz uma nova busca
    }, [query]);
    
    // Detecta o fim da página para carregar mais produtos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarProdutos();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    const adicionarAoEstoque = async(x) => {
      Swal.fire({
        title: `Adicionar ${x.nome_do_produto}`,
        text: `Você tem certeza que deseja adicionar ${x.nome_do_produto} ao seu estoque?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, confirmo",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await post({},`/gvendas/produtos/${x.id}/adicionar-no-estoque/`);
            if(response){
              Toast.fire({
                    icon: "success",
                    title: `Produto adicionado com sucesso`
              });
            }
          }catch(err){
            Toast.fire({
                    icon: "error",
                    title: `Falha ao adicionar produto`
            });
          }
        }
      });
    }
    
    const adicionarTodosAoEstoque = async() => {
      Swal.fire({
        title: `Adicionar todos produtos`,
        text: `Voçê tem certeza que deseja adicionar todos os produtos de ${empresa.nome_da_loja} ao seu estoque?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, confirmo",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await post({},`/gvendas/produtos/adicionar-todos-no-estoque/${empresa.id}/`);
            if(response){
              Toast.fire({
                    icon: "success",
                    title: `Produtos adicionados com sucesso`
              });
            }
          }catch(err){
            alert(JSON.stringify(err))
            Toast.fire({
                    icon: "error",
                    title: `Falha ao adicionar produtos`
            });
          }
        }
      });
    }

    
    return (
        <>
          <div className="">
            <Form>
              <Form.Group controlId="formBasicSearch">
                <div className="input-group">
                  <Form.Control 
                      type="text" 
                      placeholder="Digite o nome do produto" 
                      value={query} 
                      onChange={(e) => setQuery(e.target.value)} 
                  />
                  <Button variant="secondary" onClick={() => buscarProdutos(true)}>
                      <i className="bi bi-search"></i>
                  </Button>
                </div>
              </Form.Group>
            </Form>
            
            {empresa && (
            <>
              <div className="pt-2">
                    <RenderizarProduto
                          src={empresa?.logomarca}
                          text1={empresa?.telefone_whatsapp}
                          titulo={empresa?.nome_da_loja}
                          text2={(<ReactMarkdown>{empresa?.descricao}</ReactMarkdown>)}
                        />
              </div>
              <div className="text-center">
                <Button variant="secondary" onClick={() => adicionarTodosAoEstoque()} className="mt-2  text-center">
                      Adicionar todos produtos
                </Button>
              </div>
            </>
            )}

                <div className="text-muted small">
                Selecione o produto um a um para adicionar ao seu estoque.
              </div>
                <div className="list-group mt-3">
                    {produtos?.length > 0 ? (
                      produtos.map((x) => (
                        <RenderizarProduto
                          key={x.id}
                          onClick={()=>adicionarAoEstoque(x)}
                          src={x.foto_do_produto}
                          text1={x.nome_do_produto}
                          titulo={parseFloat(x.preco_unitario).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                          text2={!empresa?`Por ${x.empresa?.nome_da_loja}`:''}
                        />
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarProdutos(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};

export default Home;